module.exports = __webpack_public_path__ + "img/ditu.675bed87.png";